import { render, staticRenderFns } from "./addDeal.vue?vue&type=template&id=2d8be19e&lang=pug"
import script from "./addDeal.vue?vue&type=script&lang=js"
export * from "./addDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports